/* eslint-disable indent */

import { useState } from 'react';
import {
  BuildingOfficeIcon,
  PencilIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';

import { CardWithActions } from '@keymono/design-system';
import { IOrgNameIdentifiers } from '@keymono/shared-types';

import { OrgNamesCard } from './OrgNamesCard';
import { OrgNamesCardEdit } from './OrgNamesCardEdit';

interface IOrgNameIdentifiersCardProps {
  names: IOrgNameIdentifiers;
  orgId: string;
}

/**
 * -----------------------------------------------------------------------------
 * Displays the org's names and allows for editing.
 */
export function OrgNameIdentifiersCard({
  names,
  orgId,
}: IOrgNameIdentifiersCardProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [isSuccessVisible, setIsSuccessVisible] = useState(false);

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
  };

  const handleUpdateSuccess = () => {
    setIsEditing(false);
    setIsSuccessVisible(true);
  };

  const handleOnHideSuccessPopup = () => {
    setIsSuccessVisible(false);
  };

  /**
   * Main icon feature that distinguishes the card info.
   */
  const cardIcon = {
    Icon: BuildingOfficeIcon,
    className: 'text-teal-700 bg-teal-50',
  };

  /**
   * Actions to perform operations on the card like edit or cancel.
   */
  const mainCardAction = isEditing
    ? {
        Icon: XMarkIcon,
        title: 'Exit edit mode',
        onClick: handleCancelEdit,
      }
    : {
        Icon: PencilIcon,
        title: 'Edit the names identifiers',
        onClick: handleEdit,
      };

  return (
    <CardWithActions
      actions={isSuccessVisible ? [] : [mainCardAction]}
      isSuccessVisible={isSuccessVisible}
      onHideSuccessPopup={handleOnHideSuccessPopup}
      cardIcon={cardIcon}
    >
      {!isEditing ? (
        <OrgNamesCard names={names} />
      ) : (
        <OrgNamesCardEdit
          orgId={orgId}
          onUpdateSuccess={handleUpdateSuccess}
          names={names}
          onExitEditMode={handleCancelEdit}
        />
      )}
    </CardWithActions>
  );
}
